import React from "react";
import { Label } from "@/components/ui/label";
import { formatInput, toNumber } from "@/lib/currency";
import { cn } from "@/lib/utils";

// Rupiah-formatted numeric input. Shows thousand separators, keeps numeric keyboard.
export function RupiahInput({ label, value, onChange, placeholder = "0", testId, hint, className }) {
  const display = value ? formatInput(value) : "";

  const handle = (e) => {
    const n = toNumber(e.target.value);
    onChange(n);
  };

  return (
    <div className={cn("space-y-1.5", className)}>
      {label && (
        <Label className="text-sm font-medium text-zinc-700 font-heading">{label}</Label>
      )}
      <div className="relative">
        <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-zinc-400 font-mono text-sm">
          Rp
        </span>
        <input
          type="text"
          inputMode="numeric"
          data-testid={testId}
          value={display}
          onChange={handle}
          placeholder={placeholder}
          className="w-full rounded-2xl border border-zinc-200 bg-white py-3.5 pl-11 pr-4 text-right font-mono text-lg font-semibold text-zinc-900 outline-none transition-colors focus:border-emerald-400 focus:ring-2 focus:ring-emerald-100"
        />
      </div>
      {hint && <p className="text-xs text-zinc-400">{hint}</p>}
    </div>
  );
}
